import jwt from 'jsonwebtoken'

import { NETOP_ACCOUNTS_URL } from './env'

export function getLoginURL (currentUrl) {
  const timestamp = (new Date() / 1)
  return `${NETOP_ACCOUNTS_URL}/login?t=${timestamp}&redirectUrl=${currentUrl}`
}

export function parseJwtToken (token) {
  const info = jwt.decode(token)

  return {
    token,
    userId: info.id,
    accountId: info.accountId,
  }
}
